import React, { PropsWithChildren, ReactNode } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

type PageTitlePropsT = PropsWithChildren<{
  title: string;
  TitleAddon?: ReactNode;
  description?: ReactNode;
}>;

function PageTitle({
  title,
  TitleAddon,
  description,
  children,
}: PageTitlePropsT) {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Box sx={{ mb: 4 }}>
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item>
            {TitleAddon ? (
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography variant="h4">{title}</Typography>
                {TitleAddon}
              </Stack>
            ) : (
              <Typography variant="h4">{title}</Typography>
            )}
          </Grid>
          <Grid item>
            <Stack direction="row" spacing={2}>
              {children}
            </Stack>
          </Grid>
        </Grid>
        {typeof description === 'string' ? (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ marginTop: 1 }}
          >
            {description.split('\n').map((line, index, array) => (
              <React.Fragment key={index}>
                {line}
                {index < array.length - 1 && <br />}
              </React.Fragment>
            ))}
          </Typography>
        ) : (
          description
        )}
      </Box>
    </>
  );
}

export default PageTitle;
